import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=49d8afea&scoped=true&"
import script from "./OrderEdit.vue?vue&type=script&lang=js&"
export * from "./OrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=49d8afea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8afea",
  null
  
)

export default component.exports